import { parseSearchTermParam } from '@repo/utils';
import { createFileRoute } from '@tanstack/react-router';
import { KitsPage } from '~/components/Kits';

export type PortalSearch = {
  search?: string;
};

export const Route = createFileRoute('/_authed/portal')({
  preload: true,
  validateSearch: (search: Record<string, unknown>): PortalSearch => ({
    search: parseSearchTermParam(search.search),
  }),
  component: KitsPage,
});
